import { apiPath } from '../_utils/api-version'
import { IDeliveryZone } from '../_types'
import { request } from './http-client'

export const getCheckPointDeliveryZones = (
  params: any,
  useDynamicLanguage = false
) =>
  request.get<{ result: IDeliveryZone[]; all_count: number }>(
    apiPath('check_point_delivery_zones', useDynamicLanguage),
    {
      params,
    }
  )

export const getActiveDeliveryZones = (
  params: any,
  useDynamicLanguage = false
) =>
  request.get(apiPath('active-delivery-zones', useDynamicLanguage), { params })
